import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import theme from '../../styles/theme';
import { viewBoxSizes, } from './constants';
import logos from './logos';
const svgLogoStyles = css `
  color: ${theme.colors.gray700};
`;
const defaultProps = {
    modifier: 'minted',
};
const Logo = ({ modifier = defaultProps.modifier, }) => (_jsx("svg", Object.assign({ css: svgLogoStyles, viewBox: viewBoxSizes[modifier] }, { children: logos[modifier] })));
const MemoizedLogo = memo(Logo);
export { MemoizedLogo as Logo };
// MC-1068 Temporary hack for Storybook.
export default Logo;
